export const useGA = () => {
  const injectGA = (gTagId?: string) => {
    if (!gTagId) return;

    const scriptExists =
      document.querySelector('script[id="googletagmanager-script"]') !== null;
    if (scriptExists) return;

    const inlineScript = document.createElement("script");
    inlineScript.id = "googletagmanager-script";
    inlineScript.textContent = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gTagId}');
    `;

    document.head.appendChild(inlineScript);
  };

  return { injectGA };
};
